import React from 'react';
import { ResponsiveContainer, ContentWrapper, Spinner } from '@goparrot-dashboard/shared-ui';

export const FullPageSpinner = () => (
  <ResponsiveContainer>
    <ContentWrapper className="tw-flex">
      <div className="tw-flex-1 tw-flex tw-justify-center tw-items-center">
        <Spinner spinning isMarketComponent size="small" className="tw-pt-4" backgroundTransparency="transparent" />
      </div>
    </ContentWrapper>
  </ResponsiveContainer>
);
